function explainWhySelectionInvalid(cid, pid) {
    cid = Number(cid);
    pid = Number(pid);

    const baseMap = window.WCCP_DEBUG?.baseProductsByComponent || {};
    const effectsByComp = window.WCCP_DEBUG?.scenarioEffectsByComponent || {};

    const baseProducts = new Set(baseMap[cid] || []);
    const effects = effectsByComp[cid] || [];

    if (!baseProducts.size || !effects.length) {
        // console.warn('[WCCP] No debug data for component', cid);
        return;
    }

    let allowed = new Set(baseProducts);

    for (const eff of effects) {
        const beforeHas = allowed.has(pid);
        if (!beforeHas) {
            continue;
        }

        const beforeSet = new Set(allowed);
        const prods = eff.products || [];

        switch (eff.effect) {
            case 'available_components':
            case 'conditions.show_only_options':
            case 'legacy.conditional_options.in': {
                if (prods.length) {
                    const wl = new Set(prods);
                    allowed = new Set([...allowed].filter(x => wl.has(x)));
                }
                break;
            }
            case 'conditions.hide_options':
            case 'legacy.conditional_options.not-in': {
                if (prods.length) {
                    const bl = new Set(prods);
                    allowed = new Set([...allowed].filter(x => !bl.has(x)));
                }
                break;
            }
            case 'conditions.hide_components':
            case 'legacy.conditional_components.hidden_components': {
                allowed = new Set();
                break;
            }
        }

        const afterHas = allowed.has(pid);

        if (beforeHas && !afterHas) {
            // console.groupCollapsed(
            //     `[WCCP] Selection ${pid} for component ${cid} killed by scenario ${eff.scenarioId}`
            // );
            // console.log('Effect:', eff.effect);
            // console.log('Scenario ID:', eff.scenarioId);
            // console.log('Products specified in this effect:', prods);
            // console.log('Allowed BEFORE:', [...beforeSet]);
            // console.log('Allowed AFTER:', [...allowed]);
            // console.groupEnd();
            // return;
            return {
                reason: 'killed_by_scenario',
                component_id: cid,
                product_id: pid,
                scenario_id: eff.scenarioId,
                effect: eff.effect,
                products: prods,
                allowed_before: beforeSet,
                allowed_after: [...allowed]
            };
        }
    }

    // console.log(
    //     `[WCCP] Selection ${pid} for component ${cid} became invalid, but no single scenario effect was found as a direct killer`
    // );
}


function sanitizeSelectionsAgainstScenarios() {
    const allowedByComp = computeAllowedByComponent();

    (STATE.data?.components || []).forEach(c => {
        const cid = Number(c.id);
        const pid = STATE.selected[cid];
        if (!pid) return;

        const allowed = allowedByComp.get(cid) || new Set();
        if (!allowed.has(Number(pid))) {
            // console.error('[WCCP] Clearing selection for', cid, pid);
            if (window.WCCP_DEBUG) {
                let debugInfo = null;
                
                debugInfo = explainWhySelectionInvalid(cid, pid);
            }
            delete STATE.selected[cid];
            delete STATE.selectedVariants[cid];
        }
    });
}
